var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from '../../common/useFetch';
import DrawCategoryService from '../../domain/DrawCategoryService';
import PrizeSchemeService from '../../domain/PrizeSchemeService';
import gs from '../../styles/style';
import Duration from '../Common/Duration';
import { Errors, Form, Input, Select, SubmitButton } from '../Common/Form';
var DrawForm = function (_a) {
    var form = _a.form;
    var t = useTranslation()[0];
    var _b = useFetch(function (config) { return DrawCategoryService.getDrawCategories(config); }, {
        onSuccess: function (drawCategories) {
            if (!form.values.draw_category) {
                form.setValue('draw_category', drawCategories[0]);
            }
        },
        initialValue: []
    }), drawCategories = _b.data, getDrawCategories = _b.get;
    var _c = useFetch(PrizeSchemeService.getPrizeSchemes, {
        onSuccess: function (prizeSchemes) {
            if (!form.values.prize_scheme) {
                form.setValue('prize_scheme', prizeSchemes[0]);
            }
        },
        initialValue: []
    }), prizeSchemes = _c.data, getPrizeSchemes = _c.get;
    useEffect(function () {
        getDrawCategories();
        getPrizeSchemes();
    }, []);
    return React.createElement(Form, { form: form },
        React.createElement("div", { className: gs('card', 'mb-4') },
            React.createElement("div", { className: gs('card-body') },
                React.createElement("div", { className: gs('row') },
                    React.createElement("div", { className: gs('col-md-6') },
                        React.createElement("div", { className: gs('form-group') },
                            React.createElement("label", null, t('draw_category')),
                            React.createElement("p", { className: gs('text-muted', 'mb-2') }, t('draw_category_description')),
                            React.createElement(Select, __assign({}, form.select('draw_category', drawCategories, 'id'), { required: true }), drawCategories.map(function (drawCategory, index) { return (React.createElement("option", { value: index, key: drawCategory.id }, drawCategory.title)); })),
                            React.createElement(Errors, { attribute: "draw_category", errors: form.getErrors('draw_category') })),
                        React.createElement("div", { className: gs('form-group') },
                            React.createElement("label", null, t('prize_scheme')),
                            React.createElement("p", { className: gs('text-muted', 'mb-2') }, t('prize_scheme_description')),
                            React.createElement(Select, __assign({}, form.select('prize_scheme', prizeSchemes, 'id'), { required: true }), prizeSchemes.map(function (prizeScheme, index) { return (React.createElement("option", { value: index, key: prizeScheme.id }, prizeScheme.title)); })),
                            React.createElement(Errors, { attribute: "prize_scheme", errors: form.getErrors('prize_scheme') })),
                        React.createElement("div", { className: gs('form-group') },
                            React.createElement("label", null, t('draw_at')),
                            React.createElement("p", { className: gs('text-muted', 'mb-2') }, t('draw_at_description')),
                            React.createElement(Input, __assign({}, form.dateTime('draw_at'), { required: true })),
                            React.createElement(Errors, { attribute: "draw_at", errors: form.getErrors('draw_at') })),
                        React.createElement("div", { className: gs('form-group') },
                            React.createElement("label", null, t('cutoff_at')),
                            React.createElement("p", { className: gs('text-muted', 'mb-2') }, t('cutoff_at_description')),
                            React.createElement("div", { className: gs('input-group') },
                                React.createElement(Input, __assign({}, form.dateTime('cutoff_at'), { required: true })),
                                form.values.draw_at && form.values.cutoff_at && form.values.draw_at > form.values.cutoff_at && React.createElement("div", { className: gs('input-group-append') },
                                    React.createElement("span", { className: gs('input-group-text') },
                                        React.createElement("small", null,
                                            "\u2212 ",
                                            React.createElement(Duration, { start: form.values.cutoff_at, end: form.values.draw_at }))))),
                            React.createElement(Errors, { attribute: "cutoff_at", errors: form.getErrors('cutoff_at') })))))),
        React.createElement("div", { className: gs('text-right') },
            React.createElement(SubmitButton, { form: form, className: gs('btn-lg') }, t('save'))));
};
export default DrawForm;
